import React, { useEffect, useState } from 'react'

import { Icon } from '../../components/Icon'
import {
  // IncidentsDummyData,
  PartnerssHeaders,
  policyHeader,
} from '../../data/index'
import Menu from '../../components/UI/UIMenu'
import Modal from '../../components/UI/UIModal'

import UITextInput from '../../components/UI/UITextInput'
import UISubHeaderComponent from '../../components/UI/UISubHeaderComponent'
import Pagination from '../../components/UI/Pagination'
import '../../App.css'
import {
  createPartner,
  deletePartner,
  getPartners,
  reCreatePartnerApiKey,
  updatePartner,
} from '../../api/apiService'
import { useQuery } from 'react-query'
import {
  ErrorResponse,
  PartnerData,
  PartnersData,
  PartnersDataObjResponse,
} from '../../utils/types'
import { toast } from 'react-toastify'
import UIButton from '../../components/UI/UIButton'

import * as yup from 'yup'
import { Formik } from 'formik'
import UIFieldError from '../../components/UI/UIFieldError'
import { addStarAfterFourChars } from '../../utils/utils'
import { calculatePageCount } from './utils'

const validationSchema = yup.object().shape({
  name: yup.string().required('Name is Required'),
  address: yup.string().required('Address is Required'),
})

const Partners = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [partnerId, setPartnerId] = useState('')
  const [isView, setIsView] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [responseData, setResponseData] = useState<PartnerData>()
  const [reKey, setReKey] = useState('')
  const [isReApiKey, setIsReApiKey] = useState(false)
  const [selectedItem, setSelectedItem] = useState<PartnerData>()
  const [selectedItemIndex, setSelectedItemIndex] = useState<number | null>()
  const [name, setName] = useState('')
  const [address, setAddress] = useState('')
  const [isApiKey, setIsApiKey] = useState<boolean>(false)

  const [currentPage, setCurrentPage] = useState<number>(1)
  // Set the total number of pages here

  const getPartnersData = async (): Promise<PartnersDataObjResponse> => {
    const response = (await getPartners()) as PartnersData
    if (response?.status != 'successful') {
      console.log('error')
      // toast.error('Network Error.', {
      //   position: 'top-right',
      // })
    }
    return response?.data
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data, isLoading, isError, refetch } = useQuery(
    'partners',
    getPartnersData
  )

  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(Number(data?.count) || 100).fill(false)
  )

  const createNewPartner = async (values: {
    name: string
    address: string
  }): Promise<void> => {
    try {
      const response = (await createPartner(values)) as {
        status?: string
        data: PartnerData
      }
      if (response?.status == 'successful') {
        refetch()
        // setIsOpen(!isOpen)
        setIsApiKey(true)
        setResponseData(response?.data)
        toast.success('Partner Created.', {
          position: 'top-right',
        })
      } else {
        toast.error('partner already existed.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const removePartner = async (): Promise<void> => {
    console.log('selectedItem', selectedItem)
    setIsView(false)
    try {
      const response = (await deletePartner({ id: selectedItem?.id })) as {
        status?: string
        data: PartnerData
      }
      if (response?.status == 'successful') {
        refetch()
        handleToggleMenu(selectedItemIndex ?? null)
        setIsOpenDelete(!isOpenDelete)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  const editPartner = async (
    id: string,
    values: {
      name: string
      address: string
    }
  ): Promise<void> => {
    const response = (await updatePartner(values, id)) as {
      status?: string
      data: PartnerData
    }
    if (response?.status == 'successful') {
      setName('')
      setAddress('')
      refetch()

      setIsOpen(false)

      toast.success('Partner Updated.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const recreateKey = async (id: string): Promise<void> => {
    const response = (await reCreatePartnerApiKey(id)) as {
      status?: string
      data: {
        apiKey: string
      }
    }
    if (response?.status == 'successful') {
      setReKey(response?.data?.apiKey)

      setName('')
      setAddress('')
      refetch()

      toast.success('key reacreated', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  // const handleSort = (key: keyof incidents) => {
  //   console.log(key)
  //   const newSortOrder = { ...sortOrder }

  //   if (newSortOrder[key] === 'asc') {
  //     newSortOrder[key] = 'desc'
  //     setData([...data.sort((a, b) => (a[key] < b[key] ? 1 : -1))])
  //     console.log(data)
  //   } else {
  //     newSortOrder[key] = 'asc'
  //     setData([...data.sort((a, b) => (a[key] > b[key] ? 1 : -1))])
  //   }

  //   setSortOrder(newSortOrder)
  // }

  const handlePageChange = (pageNumber: number): void => {
    setCurrentPage(pageNumber)
    // You can add additional logic here, like fetching data for the new page
  }

  const handleToggleMenu = (rowIndex: number | null) => {
    const updatedMenuState = isOpenMenu.map((isOpen: unknown, index: number) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleOpenModal = () => {
    setIsOpen(true)
    setIsReApiKey(false)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
    setIsApiKey(false)
  }
  const handleCloseDeleteModal = () => {
    setIsOpenDelete(false)
  }

  //   const statusBgColor = (status: string): string => {
  //     switch (status) {
  //       case 'Published':
  //         return 'lightGreen'
  //       case 'Lapsed':
  //         return 'paleYellow'
  //       case 'Not Active':
  //         return 'palePink'
  //       default:
  //         return 'gray3'
  //     }
  //   }
  //   const statusBgColor = (status: string): string => {
  //     switch (status) {
  //       case 'Published':
  //         return 'lightGreen'
  //       case 'Lapsed':
  //         return 'paleYellow'
  //       case 'Not Active':
  //         return 'palePink'
  //       default:
  //         return 'gray3'
  //     }
  //   }

  const copyToClipboard = (value: string | undefined) => {
    if (value) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          toast.success('Link copied to clipboard.', {
            position: 'top-right',
          })
        })
        .catch(() => {
          toast.error('Failed to copy link to clipboard', {
            position: 'top-right',
          })
        })
    }
  }

  useEffect(() => {
    refetch()
  }, [currentPage])

  console.log('dada', data)

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      {!isView && (
        <div className="flex flex-col gap-10 w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>Partners</p>
            </div>

            <div className={'flex flex-row gap-[15px]'}>
              <div className=" gap-[10px] items-center justify-between min-w-[112px] bg-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer ">
                <p className={'font-medium text-[14px] text-text1'}>
                  Export Data
                </p>
                <Icon
                  name={'exportIcon'}
                  strokeWidth={1}
                  stroke={'#02698C'}
                  width={16}
                  height={16}
                />
              </div>

              <div
                onClick={handleOpenModal}
                className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
              >
                <p className={'font-medium text-[14px] text-white'}>
                  Create Partner
                </p>
                <Icon
                  name={'IconPlus'}
                  strokeWidth={1}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
              </div>
            </div>
          </div>

          {/* content container */}
          <>
            <div
              id={'#container'}
              className="w-full flex justify-center items-center"
            >
              {/* table component */}
              {isLoading ? (
                <div className="flex justify-center items-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-text1"></div>
                </div>
              ) : (
                <div className="overflow-hidden rounded-[16px] w-full">
                  <table className="rounded-[16px] overflow-hidden border w-full border-white">
                    <thead>
                      <tr className="bg-gray2 cursor-pointer">
                        {PartnerssHeaders?.map((item, index: number) => {
                          return (
                            <th
                              key={index}
                              className={`w-1/8 px-4 py-3 text-left ${policyHeader?.length - 1 === index ? 'border-0 border-gray2' : 'border border-white'}`}
                            >
                              <div className="flex items-center">
                                <p className="text-text1 font-semibold text-sm flex-1">
                                  {item.replace(/_/g, ' ')}
                                </p>
                                <div onClick={() => console.log('check')}>
                                  <Icon
                                    name={'IconChevronDown'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1}
                                    stroke={'#67A5B9'}
                                  />
                                </div>
                              </div>
                            </th>
                          )
                        })}
                        <th className="w-1/8 px-4 py-3 border text-left border-white"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.data?.map((item, index) => (
                        <>
                          <tr className="bg-gray1">
                            {/* Example row */}
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {index + 1}
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item?.name}
                            </td>
                            <td className="px-4  h-[48px] py-2 border border-white">
                              <div className="flex">
                                <p className="text-text1 font-medium text-[12px] flex-1">
                                  {addStarAfterFourChars(item?.apiKey)}
                                </p>
                                {/* <div
                                  className="cursor-pointer"
                                  onClick={() => copyToClipboard(item?.apiKey)}
                                >
                                  <Icon
                                    name="IconCopy"
                                    width={16}
                                    height={16}
                                    strokeWidth={1}
                                    stroke={'#02698C'}
                                  />
                                </div> */}
                              </div>
                            </td>

                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.updatedAt?.substring(0, 16)}
                            </td>

                            <td className="px-4 items-center justify-center flex   h-[48px] py-2 border border-white">
                              <Menu
                                isOpen={isOpenMenu[index]}
                                items={[
                                  // {
                                  //   label: 'View',
                                  //   onClick: () => console.log('View'),
                                  //   icon: 'IconEye',
                                  //   iconColor: '',
                                  // },
                                  {
                                    label: 'Edit',
                                    onClick: () => {
                                      setPartnerId(item.id)
                                      handleOpenModal()
                                      setName(item.name)
                                      setAddress(item.address)
                                      setIsEdit(true)
                                      handleToggleMenu(index)
                                    },
                                    icon: 'IconEdit',
                                    iconColor: '',
                                  },
                                  {
                                    label: 'Regenerate Key',
                                    onClick: () => {
                                      recreateKey(item.id)
                                      setIsOpen(true)
                                      setIsApiKey(true)
                                      setIsReApiKey(true)
                                    },
                                    icon: 'IconFileMinus',
                                    iconColor: '',
                                  },
                                  {
                                    label: 'Remove',
                                    onClick: () => setIsOpenDelete(true),
                                    icon: 'IconTrash',
                                    iconColor: '#FF6666',
                                    textColor: 'text-textError',
                                  },
                                ]}
                                type={'table'}
                                setIsOpenMenu={setIsOpenMenu}
                                isOpenMenus={isOpenMenu}
                              >
                                <div
                                  onClick={() => {
                                    setSelectedItem(item)
                                    setSelectedItemIndex(index)
                                    handleToggleMenu(index)
                                  }}
                                >
                                  <Icon
                                    name={'IconDotsVertical'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#02698C'}
                                  />
                                </div>
                              </Menu>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>

          <div className="absolute bottom-4">
            {/* Your content here */}

            <Pagination
              currentPage={currentPage}
              totalPages={calculatePageCount(Number(data?.count) || 0)}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      )}
      {isView && (
        <div style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}>
          <UISubHeaderComponent
            mainPage="Incidents"
            subPage="Incident Report No. 32"
            copy="Here you can edit and manage this incident report."
            onCreate={() => {
              handleOpenModal()
              setIsEdit(false)
            }}
            onPublish={handleOpenModal}
            onEdit={() => {
              handleOpenModal()
              setIsEdit(true)
            }}
            onDelete={() => {
              setIsOpenDelete(true)
            }}
            isViewMode={true}
          />

          {/* content container */}

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Title
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Policy Title
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Donec sed odio dui. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Duis mollis, est non
                    commodo luctus, nisi erat porttitor ligula, eget lacinia
                    odio sem nec elit.
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    File
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className="bg-white w-[268px] h-[48px] flex justify-center items-center">
                      <p>name of file.pdf</p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className="px-[20px] rounded-[72px] w-fit py-[10px] bg-lightGreen flex justify-center items-center">
                      <p>Published</p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Create at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Jan 29, 2024, 4:42:47 PM
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Jan 29, 2024, 4:42:47 PM
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Title
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Policy Title
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Donec sed odio dui. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Duis mollis, est non
                    commodo luctus, nisi erat porttitor ligula, eget lacinia
                    odio sem nec elit.
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>

          <p className={'text-text2 text-[14px] font-semibold'}>
            Further Information
          </p>

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Title
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Policy Title
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    Donec sed odio dui. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Duis mollis, est non
                    commodo luctus, nisi erat porttitor ligula, eget lacinia
                    odio sem nec elit.
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    File
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className="bg-white w-[268px] h-[48px] flex justify-center items-center">
                      <p>name of file.pdf</p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className="px-[20px] rounded-[72px] w-fit py-[10px] bg-lightGreen flex justify-center items-center">
                      <p>Published</p>
                    </div>
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
          {/* modal */}
        </div>
      )}

      <Modal isOpen={isOpen} onClose={handleCloseModal}>
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              {isEdit ? 'Edit Partner' : 'Create Partner'}
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please enter the details of Partner
            </p>
          </div>

          {/* other information */}
          {!isApiKey && (
            <Formik
              enableReinitialize
              initialValues={{
                name: name,
                address: address,
              }}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                isEdit
                  ? editPartner(partnerId, values)
                  : createNewPartner(values)
              }}
            >
              {({ handleSubmit, errors, handleChange, values, handleBlur }) => (
                <>
                  <div className="w-[416px] flex-col flex gap-4 mt-[10px]">
                    <div>
                      <UITextInput
                        error={errors?.name}
                        label={'Name*'}
                        value={values.name}
                        onChange={handleChange('name')}
                        onBlur={handleBlur('name')}
                        placeholder="Please enter your name"
                        iconName={''}
                      />
                      {errors.name ? (
                        <UIFieldError
                          className="mt-2"
                          errorMessage={errors.name}
                        />
                      ) : null}
                    </div>
                    <div>
                      <UITextInput
                        error={errors?.address}
                        label={'Address*'}
                        value={values.address}
                        onChange={handleChange('address')}
                        onBlur={handleBlur('address')}
                        placeholder="Please enter your address"
                        iconName={''}
                      />
                      {errors.address ? (
                        <UIFieldError
                          className="mt-2"
                          errorMessage={errors.address}
                        />
                      ) : null}
                    </div>

                    <UIButton
                      onClick={handleSubmit}
                      type="submit"
                      label="Create"
                    />
                  </div>
                </>
              )}
            </Formik>
          )}

          {isApiKey && (
            <div className="flex border-textError border-[1px] rounded-[20px] p-[5px]">
              <p className="text-text1 font-bold text-[12px] flex-1">
                API Key:
              </p>
              <p className="text-text1 font-medium text-[12px] flex-1">
                {responseData?.apiKey}
              </p>
              <div
                className="cursor-pointer"
                onClick={() => copyToClipboard(responseData?.apiKey)}
              >
                <Icon
                  name="IconCopy"
                  width={16}
                  height={16}
                  strokeWidth={1}
                  stroke={'#02698C'}
                />
              </div>
            </div>
          )}
          {isReApiKey && (
            <div className="flex border-textError border-[1px] rounded-[20px] p-[5px]">
              <p className="text-text1 font-bold text-[12px] flex-1">
                API Key:
              </p>
              <p className="text-text1 font-medium text-[12px] flex-1">
                {reKey}
              </p>
              <div
                className="cursor-pointer"
                onClick={() => copyToClipboard(reKey)}
              >
                <Icon
                  name="IconCopy"
                  width={16}
                  height={16}
                  strokeWidth={1}
                  stroke={'#02698C'}
                />
              </div>
            </div>
          )}
        </div>
      </Modal>
      <Modal isOpen={isOpenDelete} onClose={handleCloseDeleteModal}>
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseDeleteModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Delete Partner
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Are you sure you want to delete this Partner?
            </p>
          </div>
          <button
            onClick={() => {
              removePartner()
            }}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            onClick={() => setIsOpenDelete(!isOpenDelete)}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default Partners
